/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WaterLevelGraphRequest
 */
export interface WaterLevelGraphRequest {
  /**
   * simulation time in seconds
   */
  startTime: number;
  /**
   * Maximum number of points of history to return
   */
  historyPointsLimit?: number;
  /**
   * Subscribe for new results during simulation
   */
  subscribe: boolean;
  /**
   * Max number of items per second for subscription
   */
  subscribeRateLimit?: number;
  /**
   *
   */
  nodeId: number;
}

/**
 * Check if a given object implements the WaterLevelGraphRequest interface.
 */
export function instanceOfWaterLevelGraphRequest(value: object): value is WaterLevelGraphRequest {
  if (
    (!("startTime" in (value as Record<string, any>)) &&
      !("start_time" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startTime"] === undefined &&
      (value as Record<string, any>)["start_time"] === undefined)
  )
    return false;
  if (!("subscribe" in value) || value["subscribe"] === undefined) return false;
  if (
    (!("nodeId" in (value as Record<string, any>)) &&
      !("node_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["nodeId"] === undefined &&
      (value as Record<string, any>)["node_id"] === undefined)
  )
    return false;
  return true;
}

export function WaterLevelGraphRequestFromJSON(json: any): WaterLevelGraphRequest {
  return WaterLevelGraphRequestFromJSONTyped(json, false);
}

export function WaterLevelGraphRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WaterLevelGraphRequest {
  if (json == null) {
    return json;
  }
  return {
    startTime: json["start_time"],
    historyPointsLimit:
      json["history_points_limit"] == null ? undefined : json["history_points_limit"],
    subscribe: json["subscribe"],
    subscribeRateLimit:
      json["subscribe_rate_limit"] == null ? undefined : json["subscribe_rate_limit"],
    nodeId: json["node_id"],
  };
}

export function WaterLevelGraphRequestToJSON(json: any): WaterLevelGraphRequest {
  return WaterLevelGraphRequestToJSONTyped(json, false);
}

export function WaterLevelGraphRequestToJSONTyped(
  value?: WaterLevelGraphRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    start_time: value["startTime"],
    history_points_limit: value["historyPointsLimit"],
    subscribe: value["subscribe"],
    subscribe_rate_limit: value["subscribeRateLimit"],
    node_id: value["nodeId"],
  };
}
